import { TranslucentToastsData } from "../../../../Data/BonusUi/Toasts";
import CommonToast from "../Common/CommonToast";

const TranslucentToastsList = () => {
  return (
    <>
      {TranslucentToastsData.map((data) => (
        <CommonToast key={data.id} icon={data.icon} strongText={data.strongText} smallClass={`d-sm-block d-none ${data.smallClass}`} smallText={data.smallText} bodyText={data.bodyText} />
      ))}
    </>
  );
};
export default TranslucentToastsList;
